import { LanguageVersion } from '../../model/local/config/language-version';

export namespace ApplicationActions {
  export class ChangeLanguage {
    static readonly type = '[Application] Change language';

    constructor(public language: LanguageVersion) {}
  }

  export class SetLoading {
    static readonly type = '[Application] Set loader';

    constructor(
      public loading: boolean,
      public url: string
    ) {}
  }

  export class SetFeatureTitleKey {
    static readonly type = `[Application] Set feature title key`;

    constructor(public featureTitleKey: string) {}
  }
}
